import { DEPLOYMENT_ID } from './deployment-version';

// Only the documented operations URL requests this read-only diagnostic.
export class DeploymentCheck {
    public enabled = new URLSearchParams(location.search).get('connection-check') === '1';
    public complete = false;
    public frontend = DEPLOYMENT_ID;
    public server = '';
    public version = '확인 중';
    public rows: {name: string; status: number; category: string; code: string}[] = [];
    async load() {
        if (!this.enabled) return;
        for (const [name, url] of [
            ['상태', '/api/saju/status/health'],
            ['인증', '/api/saju/profiles/session'],
            ['서비스 준비', '/api/saju/status/readiness']
        ]) {
            try {
                const response = await fetch(url, {cache: 'no-store', credentials: 'omit', signal: AbortSignal.timeout(10000)});
                const body = await response.json();
                const category = response.ok ? '정상' : [401,403].includes(response.status) ? '권한 오류' : response.status >= 500 ? '서버 오류' : '요청 오류';
                this.rows.push({name, status: response.status, category, code: body.error_code || ''});
                if (name === '상태' && response.ok) this.server = body.data.deployment_id;
            } catch { this.rows.push({name, status: 0, category: '연결 오류', code: 'RESPONSE_UNAVAILABLE'}); }
        }
        this.version = this.server === this.frontend ? '프런트·서버 버전 일치' : '버전 불일치 또는 확인 불가';
        this.complete = true;
    }
}
